import React, { useState } from "react"

import {
  Button,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import Spinners from "components/Common/Spinner"
import { useFormik } from "formik"
import * as Yup from "yup"
import toast from "react-hot-toast"
import { useInviteInvestorMutation } from "store/api/wealthpartnerapi/referrals/referrals.api"
import { useSelector } from "react-redux"

const defaultValues = {
  entity_type: "COMPANY",
  name: "",
  email: "",
  pan_no: "",
}

function AddReferalModal({ open, setOpen, refresh }) {
  const { user } = useSelector((state) => state.user)
  const toggle = () => setOpen(!open)
  const [inviteInvestor, { isLoading }] = useInviteInvestorMutation()

  const onFormSubmit = async (values) => {
    try {
      const { message, success } = await inviteInvestor({
        ...values,
        referral_code: user?.unique_code,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "toastMessage" })
        refresh()
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }

      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { ...defaultValues },
    validationSchema: Yup.object({}),
    onSubmit: async (values) => {
      await onFormSubmit(values)
    },
  })

  return (
    <div>
      <Modal isOpen={open} toggle={toggle} centered>
        <ModalHeader
          toggle={() => {
            setOpen((prev) => !prev)
          }}
        >
          Invite Investor
        </ModalHeader>
        <ModalBody>
          <Container>
            <Form
              className="form-horizontal"
              onSubmit={(e) => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <Row className="mb-2">
                <Col xl={12} className="mb-2">
                  <Label className="form-label">{"Company Name"}</Label>
                  <Input
                    name="name"
                    className="form-control"
                    placeholder={"Enter Company Name"}
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.name}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={12} className="mb-2">
                  <Label className="form-label">Email Address</Label>
                  <Input
                    name="email"
                    className="form-control"
                    placeholder="Enter Email Address"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email || ""}
                    invalid={
                      validation.touched.email && validation.errors.email
                        ? true
                        : false
                    }
                  />
                  {validation.touched.email && validation.errors.email ? (
                    <FormFeedback type="invalid">
                      {validation.errors.email}
                    </FormFeedback>
                  ) : null}{" "}
                </Col>

                <Col xl={12} className="mb-2">
                  <Label className="form-label">PAN</Label>
                  <Input
                    name="pan_no"
                    className="form-control"
                    placeholder="PAN"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.pan_no || ""}
                    invalid={
                      validation.touched.pan_no && validation.errors.pan_no
                        ? true
                        : false
                    }
                  />
                  {validation.touched.pan_no && validation.errors.pan_no ? (
                    <FormFeedback type="invalid">
                      {validation.errors.pan_no}
                    </FormFeedback>
                  ) : null}
                </Col>
              </Row>

              <div className="mt-3 py-1 button-wrapper">
                <Button
                  type="submit"
                  color="primary"
                  className="w-100"
                  disabled={isLoading}
                >
                  {isLoading ? <Spinners /> : "Invite Investor"}
                </Button>
              </div>
            </Form>
          </Container>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default AddReferalModal
